import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId300000001: SiteIdOverrideConfig = {
  car: {
    timeFormats: {
      timeFormat12Hour: true,
    },
  },
};
